import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { useMeContext } from '~/modules/me';
import { AlertMessageDialog } from '~/modules/common/components';
import { useProjectTasksCount } from '~/modules/common/hooks/project';
import ReleaseAllocationsDialog from './ReleaseAllocationsDialog';

const useStyles = makeStyles(theme => ({
  paper: {
    width: theme.spacing(75),
    height: theme.spacing(31)
  }
}));

const noViewTaskPermissionMessageInfo = {
  title: {
    messageId: 'releaseResourceRequestDialog.viewTaskPermissionError.title'
  },
  messages: [
    {
      messageId: 'releaseResourceRequestDialog.viewTaskPermissionError.message'
    },
    {
      messageId:
        'releaseResourceRequestDialog.viewTaskPermissionError.projectMessage'
    }
  ]
};

const ReleaseAllocationsDialogWrapper = ({
  canViewTask,
  open,
  onCancelClick,
  projectUri,
  ...rest
}) => {
  const classes = useStyles();
  const {
    featureFlags: { isPsaRmpEnhancedProjectManagerPersonaEnabled }
  } = useMeContext();

  const { tasksCount, loading: loadingTasksCount } = useProjectTasksCount({
    projectId: projectUri,
    skip: !isPsaRmpEnhancedProjectManagerPersonaEnabled || canViewTask
  });

  const hasProjectTasks = Boolean(tasksCount);

  if (
    isPsaRmpEnhancedProjectManagerPersonaEnabled &&
    !canViewTask &&
    (hasProjectTasks || loadingTasksCount)
  ) {
    return (
      <AlertMessageDialog
        open={open}
        onClose={onCancelClick}
        dialogTitleId="releaseResourceRequestDialog.releaseResource"
        closeButtonId="releaseResourceRequestDialog.ok"
        severity="error"
        messageInfo={noViewTaskPermissionMessageInfo}
        classes={classes}
        isLoading={loadingTasksCount}
      />
    );
  }

  return (
    <ReleaseAllocationsDialog
      open={open}
      onCancelClick={onCancelClick}
      projectUri={projectUri}
      canViewTask={canViewTask}
      {...rest}
    />
  );
};

ReleaseAllocationsDialogWrapper.propTypes = {
  allocatedUser: PropTypes.object,
  canEditTask: PropTypes.bool.isRequired,
  canViewTask: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onReleaseResourceAllocation: PropTypes.func,
  onReleaseSuccess: PropTypes.func,
  open: PropTypes.bool.isRequired,
  projectUri: PropTypes.string,
  selectedAllocationId: PropTypes.string
};

export default ReleaseAllocationsDialogWrapper;
